import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=094f2bcc&scoped=true&lang=pug&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=094f2bcc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f2bcc",
  null
  
)

export default component.exports